/* Velezeco — stepper −/+ nas linhas do carrinho (nativo).
   Delegação no document (sobrevive aos re-renders do drawer). Ao clicar,
   ajusta o input e dispara 'change' que borbulha até <line-item-quantity>,
   que é quem o tema usa para chamar /cart/change. Sem libs, à prova de erro. */
(function () {
  if (window.__vzQtyStepper) return; window.__vzQtyStepper = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.vz-qty-btn') : null;
    if (!btn) return;
    var stepper = btn.closest('.vz-stepper'); if (!stepper) return;
    var input = stepper.querySelector('.quantity-input'); if (!input) return;

    var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
    var cur = parseInt(input.value, 10); if (isNaN(cur)) cur = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    var next = cur + step;
    if (next < 1) next = 1;
    if (!isNaN(max) && next > max) next = max;
    if (next === cur) return;

    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
